import {HttpClient} from '@angular/common/http';
import {Storage} from '@ionic/storage';
import { SimpleCommand } from './command-parser';
import {CommandActionInterface, CommandActionBase} from './command-action';
import {GlobalServiceProvider, Participant} from "../../providers/global.service";
// import { NewlyCreatedComponentProvider} from "../../providers/newly-created-component/newly-created-component";

import { ListCommandsAction} from "./list-commands/list-commands-action";


import {ParticipantListCmdAction} from "./participant-list-cmd/participant-list-cmd-action";
import {DocumentListCmdAction} from "./document-list-cmd/document-list-cmd-action";
import {Injectable} from "@angular/core";
import {CreateCmdAction} from "./create-cmd/create-cmd-action";



@Injectable()
export class CommandResolver {

  public static commandHistory: Array<String> = [];



  constructor(public global:GlobalServiceProvider)
  {

  }


  public static commandSet={
    "?":ListCommandsAction.getNew,
    participants:ParticipantListCmdAction.getNew,
    documents:DocumentListCmdAction.getNew,
    create:CreateCmdAction.getNew,
  }









  public execute(commandString) {
    let simpleCommands:Array<SimpleCommand> = SimpleCommand.parsePipes(commandString);
    //TODO: take care of pipes
    if (simpleCommands.length == 1) return this.executeCommand(simpleCommands[0]);
  }

  public executeCommand(simpleCommand:SimpleCommand) {


    return new Promise((resolve, reject) => {


      if (!CommandResolver.commandSet[simpleCommand.command]) {
        reject("command not found");
      }
      else {



        let commandAction = CommandResolver.commandSet[simpleCommand.command].call(this);
        commandAction.global = this.global;

        commandAction.do(simpleCommand.commandString).then((result) => {

          resolve(result);

        }).catch((commandExecutionError) => {

          reject(commandExecutionError);
        });
      }

    })

  }

}



// WEBPACK FOOTER //
// ./src/components/commands/command-resolver.ts